export default function scrollToTop(){
    const container = document.getElementById("customScroll");
    if (container) {
        container.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
}